export const selectData=state=>state.data.data;
export const selectLoading=state=>state.data.loading;
export const selectError=state=>state.data.error;